import React, { Component } from 'react';
/* Components */

class ModalSurvey extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.modal==true
      && prevProps.statusSave!=200 && this.props.statusSave==200
      && this.props.datos.closeOnSuccessTime && this.props.datos.closeOnSuccessTime>0) {
        setTimeout(() => {
          this.props.hideModal();
        }, this.props.datos.closeOnSuccessTime*1000);
    }
  }

  render() {
    if(!this.props.modal || !this.props.datos.surveyToAnswer) {
      return null;
    }

    var question = null;
    var alternatives = [];
    var feedbackMessage = "goodNps";

    if (this.props.datos.questions &&
      this.props.actualSurveyQuestion < this.props.datos.questions.length) {
      question = this.props.datos.questions[this.props.actualSurveyQuestion];
      for (var i = 0; i < 10; i++) {
        const answervalue = i + 1;
        alternatives.push((
          <div
            key={i}
            className={"survey-alternative survey-alternative-" + i}
            onClick={this.props.handleAnswer}
            data-answervalue={answervalue}
            data-questiondata={JSON.stringify(question)}
            data-lastquestion={this.props.actualSurveyQuestion == this.props.datos.questions.length - 1 ? true : null}
          >
            {answervalue}
          </div>
        ));
      }
    }

    if (this.props.statusSave == 200) {
      if (this.props.surveyAnswersAvg >= 1 && this.props.surveyAnswersAvg <= 6) {
        feedbackMessage = "badNps";
      }
      else if (this.props.surveyAnswersAvg > 6 && this.props.surveyAnswersAvg <= 7) {
        feedbackMessage = "regularNps";
      }
      else if (this.props.surveyAnswersAvg > 7 && this.props.surveyAnswersAvg <= 10) {
        feedbackMessage = "goodNps";
      }
    }

    return (
      <div
        data-close="ok"
        onClick={((!this.props.datos.mandatory || this.props.statusSave!=null) && this.props.loadingSave == false) ?
          this.props.handleModal : null
        }
        className={(this.props.statusSave==null && this.props.loadingSave == false) ?
          `container-modal container-modal-survey` :
          `container-modal container-modal-survey container-modal-survey-feedback`
        }
      >
        <section className="module-title modal-title">
          {((!this.props.datos.mandatory || this.props.statusSave!=null) && this.props.loadingSave == false) && (
            <a>
              <i data-close="ok" onClick={this.props.handleModal} className="fas fa-times-circle" />
            </a>
          )}
        </section>
        <div className={`box-modal`}>
        {(this.props.statusSave == null &&
          this.props.loadingSave == false && question!=null) ? (
          <section id="modal-survey" className="base-form">
            <div className="survey-question">
              {question.question}
            </div>
            <div className="survey-alternatives-wrapper">
              {alternatives}
            </div>
            <div className="survey-labels-wrapper">
              <div className="survey-label-bottom">
                {question.bottomScaleValueLabel}
              </div>
              <div className="survey-label-top">
                {question.topScaleValueLabel}
              </div>
            </div>
            <div className="survey-disclaimer">
              {this.props.language.survey.disclaimer}
            </div>
            <div className="survey-questions-bullets">
            {this.props.datos.questions.map((item,i) => {
              return (
                <div key={"bullet-"+i} className={"question-bullet" +
                  ((i==this.props.actualSurveyQuestion) ? " question-bullet-active" : "")}/>
              );
            })}
            </div>
          </section>
        ) : this.props.loadingSave ? (
          <section id="modal-survey" className="base-form">
            <div className="spiner">
              <i className="fas fa-spinner fa-spin" /> {this.props.language.survey.loading}
            </div>
          </section>
        ) : this.props.statusSave==200 ? (
          <section id="modal-survey" className="base-form feedback-survey">
            <div className={"feedback-survey-icon feedback-survey-icon-" + feedbackMessage}/>
            <div className="feedback-survey-1">
              {this.props.language.survey.feedbackMessages[feedbackMessage].message1}
            </div>
            <div className="feedback-survey-2">
              {this.props.language.survey.feedbackMessages[feedbackMessage].message2}
            </div>
          </section>
        ) : (this.props.statusSave!=null && this.props.statusSave!=200) ? (
          <section id="modal-survey" className="base-form feedback-survey  feedback-survey-error">
            <div className="feedback-survey-1">
              {this.props.language.survey.feedbackMessages.error.message1}
            </div>
            <div className="feedback-survey-2">
              {this.props.language.survey.feedbackMessages.error.message2}
            </div>
          </section>
        ) : (
          <section id="modal-survey" className="base-form">
          </section>
        )}
        </div>
      </div>
    );
  }
}

export default ModalSurvey;



// WEBPACK FOOTER //
// ./source/client/components/survey/modalSurvey.jsx